// PROTOTYPE (hero shapes): where each client's dot goes in Cerchio. A layout
// is in CSS pixels of the box it is drawn in, and lists the dots in the order
// they fill: the clients you meet first, then the others in the order the
// reveal reaches them. It is { dots: [{ x, y, k? }], size, pitch, width,
// height }: `size` is a dot's diameter, and `k` a dot's own scale, 1 if
// missing. Costellazione moves these dots (transitionFrames.js).

const GOLDEN_ANGLE = 2.399963;
const RADIUS = 46;

// One dot per client on a sunflower spiral, so index order runs from the
// centre outwards. `hollow` (0 to 1) leaves an empty middle of that share of
// the radius. Positions are percentages of the disc's box.
function sunflower(clients, hollow) {
  const area = Math.PI * RADIUS * RADIUS * (1 - hollow * hollow);
  const size = Math.max(0.9, Math.min(5, 0.86 * Math.sqrt(area / clients)));
  const dots = [];
  for (let i = 0; i < clients; i += 1) {
    const reach = Math.sqrt(hollow * hollow + (1 - hollow * hollow) * ((i + 0.5) / clients));
    const angle = i * GOLDEN_ANGLE;
    dots.push({ left: 50 + RADIUS * reach * Math.cos(angle), top: 50 + RADIUS * reach * Math.sin(angle) });
  }
  return { size, dots };
}

// The clients on the sunflower spiral, from the hollow in its middle
// outwards, in a square `side` pixels across.
export function discLayout({ clients, side, hollow }) {
  const { size, dots } = sunflower(clients, hollow);
  const px = side / 100;
  const across = size * px;
  return {
    dots: dots.map(({ left, top }) => ({ x: left * px, y: top * px })),
    size: across,
    pitch: across / 0.86,
    width: side,
    height: side,
  };
}
